import { AppNS } from 'app';

import { Box, Card, CardContent, LinearProgress, Pagination, useMediaQuery, useTheme } from '@mui/material';

import BookingsList from '../bookings-list/BookingsList';
import BookingsTable from '../bookings-table/BookingsTable';

export interface BookingsDataProps {
  data: AppNS.ProjectLead[];
  page: string;
  totalPages: number;
  isFetching: boolean;
  onPageChange: (page: string) => void;
}

export default function BookingsData(props: BookingsDataProps) {
  const { data, onPageChange, isFetching, page, totalPages } = props;
  const theme = useTheme();
  const matchesTablet = useMediaQuery(theme.breakpoints.up('tablet'));

  const currentPage = Number(page);

  const handleChange = (event: React.ChangeEvent<unknown>, value: number) => {
    onPageChange(String(value));
  };

  return (
    <Box mb={!matchesTablet ? 11 : 0}>
      <Box minHeight="4px">
        {isFetching && (
          <Box sx={{ width: '100%' }}>
            <LinearProgress color="secondary" />
          </Box>
        )}
      </Box>
      {!matchesTablet && <BookingsList data={data} />}
      {matchesTablet && <BookingsTable data={data} />}
      {totalPages > 0 && (
        <Box mt={-4}>
          <Card>
            <CardContent>
              <Box display="flex" justifyContent={matchesTablet ? 'flex-end' : 'center'}>
                <Pagination count={totalPages} page={currentPage} onChange={handleChange} />
              </Box>
            </CardContent>
          </Card>
        </Box>
      )}
    </Box>
  );
}
